'use strict';

import {isTouch} from '../utils';
// import resizeStore from '../resize/resize.store';



class Light {
  constructor() {
    this._onUpdateArray = [];

    this._newX = 0;
    this._newY = 0;
    this._aniX = 0;
    this._aniY = 0;

    this._RESISTANCE = 0.1;

    if (isTouch()) return;

    this._el = document.createElement('div');

    this._el.style.cssText = `
      width:200px;
      height:200px;
      display:block;
      border-radius:50%;
      position:fixed;
      top:-100px;
      left:-100px;
      z-index:-1;
      will-change:transform;
      transform:translate3d(0,0,0);
      pointer-events:none;
      background-color:#0A0A0B;
    `;

    document.body.appendChild(this._el);

    // this.onResize = (e) => this._onResize(e);
    this.onAnimate = (e) => this._onAnimate(e);
    this.onMove = (e) => this._onMove(e);
    // this.onFocus = (e) => this._onFocus(e);
    // this.onBlur = (e) => this._onBlur(e);

    // resizeStore.eventEmitter.subscribe(this.onResize);
    document.documentElement.addEventListener('mousemove', this.onMove);


    this._raf = requestAnimationFrame(this.onAnimate);
  }

  // _onResize(e) {
  //
  // }
  _onMove(e) {
    this._newX = e.clientX;
    this._newY = e.clientY;
  }
  // _onFocus() {
  //
  // }
  // _onBlur() {
  //
  // }

  _onAnimate() {
    const nx = (this._newX - this._aniX) * this._RESISTANCE;
    const ny = (this._newY - this._aniY) * this._RESISTANCE;

    this._aniX += nx;
    this._aniY += ny;

    if (Math.abs(this._newX - this._aniX) > this._RESISTANCE / 2 || Math.abs(this._newY - this._aniY) > this._RESISTANCE / 2) {
      this._update();
    }

    this._raf = requestAnimationFrame(this.onAnimate);
  }

  _update() {
    const x = this._aniX;
    const y = this._aniY;

    this._el.style.transform = `translate3d(${x}px, ${y}px, 0)`;

    this._onUpdateArray.forEach(func => func({x, y}));

    // document.documentElement.style.setProperty('--x', `${this._aniX}px`);
    // document.documentElement.style.setProperty('--y', `${this._aniY}px`);
  }

  get x() {
    return this._aniX;
  }
  get y() {
    return this._aniY;
  }

  addListener(func /*function*/) {
    if (typeof func !== 'function') return;

    this._onUpdateArray.push(func);
  }
  removeListener(func /*function*/) {
    if (typeof func !== 'function') return;

    for (let i = 0; this._onUpdateArray.length > i; i++ ) {
      if (this._onUpdateArray[i] === func) {
        this._onUpdateArray.splice(i, 1);
        break;
      }
    }
  }
}


export default new Light();